'use client';

import { LeftArrowOutlined, RightArrowOutlined } from '@zeelool/icon';
import React from 'react';

interface RelationsSwiperNavigationProps {
  // 自定义导航按钮选择器前缀，用于区分不同的 Swiper 实例
  navigationPrefix?: string;
  disablePrev?: boolean;
  disableNext?: boolean;
}

const RelationsSwiperNavigation: React.FC<RelationsSwiperNavigationProps> = ({
  navigationPrefix = 'swiper-nav',
  disablePrev = false,
  disableNext = false,
}) => {
  // 生成唯一的导航按钮类名
  const prevButtonClass = `${navigationPrefix}-prev`;
  const nextButtonClass = `${navigationPrefix}-next`;
  const disabledClass = 'opacity-30 cursor-not-allowed';

  return (
    <div
      className="absolute right-0 inline-flex top-[-10px]"
      style={{ transform: 'translateY(calc(-100% - 1px))' }}
    >
      {/* Previous Button */}
      <LeftArrowOutlined
        className={`swiper-nav-icon ${prevButtonClass} ${disablePrev ? disabledClass : 'cursor-pointer'}`}
      />

      <RightArrowOutlined
        className={`swiper-nav-icon ${nextButtonClass}  ${disableNext ? disabledClass : 'cursor-pointer'}`}
      />
    </div>
  );
};

export default RelationsSwiperNavigation;
